module.exports = __webpack_public_path__ + "img/img_prize.8cd3c330.png";